const TOGGLE_SELECTED = 'PAZE_TOGGLE_SELECTED';
const SET_READY = 'PAZE_SET_READY';

export {
    TOGGLE_SELECTED, SET_READY
};
